<template>
  <div class="PhotoSir">
    <!-- 一：轮播图 -->
    <div class="banner-img-box">
        <el-carousel class="banner-switch">
          <el-carousel-item v-for="(item, index) in state.bannersData" :key="index" @click="gotoOpen(item.url)" class="cur">
            <img :src="isPhone? item.bannerImgH5 : item.bannerImg" alt="" style="width: 100%;">
          </el-carousel-item>
        </el-carousel>
    </div>
    <!-- 二：应用下载 -->
    <div class="product-download d-flex w-100">
      <div class="product-box d-flex justify-content-between m-auto">
        <div class="product-card d-flex justify-content-between flex-column" v-for="(item,index) in state.productData" :key="index">
        <div class="d-flex justify-content-between align-items-center ">
          <div class="d-flex align-items-center">
            <img :src="item.headImg" alt="" class="product-headImg">
            <div>
              <div class="product-name">{{ item.name }}</div>
              <div class="product-introduce">{{ item.introduce }}</div>
            </div>
          </div>
          <a :href="item.downloadUrlData.url" target="_blank" @click="ptype(item.downloadUrlData)">
            <div class="btn-down cur text-center text-white">立即下载 <img src="@/assets/images/TwentyFiveNewHome/goTo.png" alt=""></div>
          </a>
        </div>
        <img :src="item.img" alt="" class="photosir-img">
      </div>
      </div>
    </div>
    <!-- 三：功能 -->
    <div class="fun-section w-100">
      <div class="fun-box m-auto">
        <h2>AI赋能改变设计</h2>
        <div class="fun-card-box">
          <div v-for="(item,index) in state.aiFunData" :key="index" class="fun-card text-white" :style="{ background: item.bgColor}">
            <img :src="item.img" alt="" class="mb-1 fun-img">
            <div class="d-flex align-items-end justify-content-between">
              <div>
                <div class="fun-name">{{ item.name }}</div>
                <div class="fun-introduce">{{ item.introduce }}</div>
              </div>
              <div class="goTo text-white text-center d-flex cur" @click="goToOpenUrl(item)">
                去试试 <img src="@/assets/images/TwentyFiveNewHome/goTo.png" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 四：场景应用 -->
    <div class="application-scenarios w-100">
      <div class="box m-auto">
        <div class="d-flex align-items-center justify-content-between">
          <h2 class="text-white">亦心科技场景应用</h2>
          <div class="d-flex align-items-center currPage text-white phone-hide">
            <img src="@/assets/images/TwentyFiveNewHome/left.png" alt="" class="cur" @click="prev">
            &ensp;{{ state.currentIndex + 1 }}/2&ensp;
            <img src="@/assets/images/TwentyFiveNewHome/right.png" alt="" class="cur" @click="next">
          </div>
        </div>
        <div class="introduce">提供用于内容创作、图片处理、简单编程处理等各种解决方案</div>
      </div>
        <el-carousel class="phone-hide" :autoplay="false" arrow="never" indicator-position="none" :initial-index="state.currentIndex" ref="carouselRef">
          <el-carousel-item>
            <div class="d-flex card-box">
              <div v-for="(item,index) in state.applicationDataOnePage" :key="index" class="application-card cur text-white d-flex flex-column justify-content-between" @click="goToOpenUrl(item)" :style="{ background: item.bgColor}">
              <div class="ps-3 pt-3">
                <div class="name">{{ item.name }} <img src="@/assets/images/TwentyFiveNewHome/goTo.png" alt=""></div>
                <div class="introduce">{{ item.introduce }}</div>
              </div>
              <img :src="item.img" alt="">
              </div>
            </div>
          </el-carousel-item>
          <el-carousel-item>
            <div class="d-flex card-box">
              <div v-for="(item,index) in state.applicationDataTwoPage"  :key="index" class="application-card cur text-white d-flex flex-column justify-content-between" @click="goToOpenUrl(item)" :style="{ background: item.bgColor}">
              <div class="ps-3 pt-3">
                <div class="name">{{ item.name }} <img src="@/assets/images/TwentyFiveNewHome/goTo.png" alt=""></div>
                <div class="introduce">{{ item.introduce }}</div>
              </div>
              <img :src="item.img" alt="">
            </div>
            </div>
          </el-carousel-item>
        </el-carousel>
       <div class="phone-show">
        <div class="d-flex card-box phone-roll">
            <div v-for="(item,index) in [...state.applicationDataOnePage, ...state.applicationDataTwoPage]" @click="goToOpenUrl(item)" :key="index" class="application-card text-white d-flex flex-column justify-content-between" :style="{ background: item.bgColor}">
          <div class="ps-3 pt-3">
            <div class="name">{{ item.name }} <img src="@/assets/images/TwentyFiveNewHome/goTo.png" alt=""></div>
            <div class="introduce">{{ item.introduce }}</div>
          </div>
          <img :src="item.img" alt="">
        </div>
        </div>
       </div>
    </div>
    <!-- 五：客户案例 -->
    <div class="customer-case w-100">
      <div class="case-box m-auto">
        <h2>客户案例</h2>
        <div class="introduce">聚焦不同客户行业场景提供专业的解决方案</div>
        <div class="d-flex cases">
          <div class="case-1 cur" @click="schoolDetails(0)">
            <div class="info">
              <div class="scheme-title">中小学客户解决方案</div>
              <div class="conternt">悟空图像-AI闪绘旨在通过视觉化学习提升学生的理解和创造力。它通过智能图像识别、标注和AI辅助设计，帮助学生在完成作业、项目和创意表达时更加高效和有趣，简化图像创作流程，使学生能够更轻松创作出属于自己的梦想中的画作。</div>
            </div>
          </div>
          <div>
            <div class="case-2 cur" @click="schoolDetails(1)">
              <div>政府PS替代产品解决方案</div>
            </div>
            <div class="case-3 cur" @click="schoolDetails(2)">
              <div>职业高校客户解决方案</div>
            </div>
          </div>
        </div>
     </div>
    </div>
    <!-- 六：新闻中心 -->
    <div class="new-center w-100">
      <div class="new-box m-auto">
        <div class="d-flex align-items-center justify-content-between">
          <h2>新闻中心</h2>
          <div class="more cur text-white text-center" @click="gotoNew">了解更多 <img src="@/assets/images/TwentyFiveNewHome/goTo.png" alt=""></div>
        </div>
        <div class="introduce">
          为您呈现最新的企业新闻、品牌活动与产品动态
        </div>
        <div class="d-flex justify-content-between phone-roll">
          <div v-for="(item,index) in state.newsCenterData" :key="index" class="news-Center-card cur"  @click="itemClick(item)">
          <div class="cover-image-box">
            <img :src="item.imgurl" alt="" style="max-width: 100%;max-height: 100%">
          </div>
          <div class="new-info">
            <div class="title">{{ item.title }}</div>
            <div class="item-more cur">了解更多</div>
          </div>
        </div>
        </div>
        <div class="more-phone text-white text-center" @click="gotoNew">了解更多 <img src="@/assets/images/TwentyFiveNewHome/goTo.png" alt=""></div>
      </div>
    </div>
    <!-- 七：外部跳转 -->
    <div class="w-100 py-5" style="background: #fff;">
      <div class="d-flex flex-wrap justify-content-between align-items-center w-75 m-auto external-jump">
        <a v-for="(item, index) in state.thirdList"
           :key="index"
           :href="item.path"
           target="_blank">
          <div style="background-color: #257CFF;border-radius: 50px;"><img :src="item.icon" alt="img-icon" class="outer-net"></div>
        </a>
    </div>
    </div>
  </div>
</template>

<script setup>
import { useRoute,useRouter } from 'vue-router'
import { onMounted, reactive, ref, onUnmounted } from 'vue'
import { getNewsList, getVisit, getInstallPackUrl, getclicks } from '../utils/api'
const router = useRouter()
const route = useRoute()
const state = reactive({
  // 1
  bannersData: [
    {
      bannerImg: 'https://cdn.photosir.cn/paramter/825227748879368192.jpg',
      bannerImgH5: 'https://cdn.photosir.cn/paramter/825227027220004864.png',
      url:window.SITE_CONFIG.officialWebsiteBaseUrl + '/#/AiFlashDrawing?type=aipc'
    },
    {
      bannerImg: 'https://cdn.photosir.cn/paramter/800211856923820032.jpg',
      bannerImgH5: 'https://cdn.photosir.cn/paramter/800212905420128256.jpg',
      url:''
    },
    {
      bannerImg: 'https://cdn.photosir.cn/paramter/800212052453883904.jpg',
      bannerImgH5: 'https://cdn.photosir.cn/paramter/800213009531142144.jpg',
      url:window.SITE_CONFIG.websiteBaseUrl + '/#/inviteNewUser'
    }, {
      bannerImg: 'https://cdn.photosir.cn/paramter/800212208800759808.jpg',
      bannerImgH5: 'https://cdn.photosir.cn/paramter/800213115097579520.jpg',
      url: window.SITE_CONFIG.officialWebsiteBaseUrl + '/#/ActivityDetails?activityid=32'
    }, {
      bannerImg: 'https://cdn.photosir.cn/paramter/800212304237953024.jpg',
      bannerImgH5: 'https://cdn.photosir.cn/paramter/800213553867915264.jpg',
      url: window.SITE_CONFIG.saasUrl + '/#/toolbox'
    },
    {
      bannerImg: 'https://cdn.photosir.cn/paramter/800212392704212992.jpg',
      bannerImgH5: 'https://cdn.photosir.cn/paramter/800213647690301440.jpg',
      url: window.SITE_CONFIG.officialWebsiteBaseUrl + '/#/AiFlashDrawing'
    }
  ],
  // 2
  productData: [
    {
      name: '悟空图像',
      introduce: '更智能、更高效、更好用',
      productid_key: 'products_name_1',
      headImg: require('@/assets/images/TwentyFiveNewHome/phontosir.png'),
      img: 'https://cdn.photosir.cn/paramter/800226111576342528.jpg',
      downloadUrlData: ''
    },
    {
      name: '亦心AI闪绘',
      introduce: '实时绘画 实时创作',
      productid_key: 'products_name_31',
      headImg: require('@/assets/images/TwentyFiveNewHome/photosirAI.png'),
      img: 'https://cdn.photosir.cn/paramter/800226375595196416.jpg',
      downloadUrlData: ''
    }
  ],
  // 3
  aiFunData: [
    {
      img: 'https://cdn.photosir.cn/paramter/800219963594899456.png',
      name: '一键生图',
      introduce: '一键生成，创意图片',
      bgColor: 'linear-gradient( 139deg, #0C45FF 0%, #43F2FF 100%)',
      linkUrl: window.SITE_CONFIG.aigcBaseUrl + '/#/fluxMakingForModel'
    },
    {
      img: 'https://cdn.photosir.cn/paramter/800220156088287232.png',
      name: 'AI海报',
      introduce: '小白也可以，快速生成海报',
      bgColor: 'linear-gradient( 138deg, #9900FF 0%, #FF94C8 100%)',
      linkUrl: window.SITE_CONFIG.saasUrl + '/#/AIPoster'
    },
    {
      img: 'https://cdn.photosir.cn/paramter/800220293468520448.png',
      name: '艺术字',
      introduce: 'AI轻松帮你搞定艺术字',
      bgColor: 'linear-gradient( 138deg, #04A44C 0%, #FFFA9E 100%)',
      linkUrl: window.SITE_CONFIG.aigcBaseUrl + '/#/making?type=artfont'
    },
    {
      img: 'https://cdn.photosir.cn/paramter/800220405280276480.png',
      name: '商品图',
      introduce: '轻松解决商品图问题',
      bgColor: 'linear-gradient( 139deg, #F03939 0%, #FFED75 100%)',
      linkUrl: window.SITE_CONFIG.aigcBaseUrl + '/#/making?type=wares'
    },
    {
      img: 'https://cdn.photosir.cn/paramter/800220502009315328.png',
      name: 'AI模特',
      introduce: 'AI模特，美在未来',
      bgColor: 'linear-gradient( 139deg, #F03939 0%, #FFED75 100%)',
      linkUrl: window.SITE_CONFIG.aigcBaseUrl + '/#/makingForModel'
    },
    {
      img: 'https://cdn.photosir.cn/paramter/800220903848804352.png',
      name: '动态漫',
      introduce: '一键创作，心中的动漫',
      bgColor: 'linear-gradient( 138deg, #04A44C 0%, #FFFA9E 100%)',
      linkUrl: window.SITE_CONFIG.aigcBaseUrl + '/#/aiCartoon'
    },
    {
      img: 'https://cdn.photosir.cn/paramter/800220991748833280.png',
      name: 'AI工具箱',
      introduce: '使用工具，快速处理图片',
      bgColor: 'linear-gradient( 139deg, #9900FF 0%, #FF94C8 100%)',
      linkUrl: window.SITE_CONFIG.saasUrl + '/#/toolbox'
    },
    {
      img: 'https://cdn.photosir.cn/paramter/800221090608578560.png',
      name: '自定义生成图片',
      introduce: '高级生成，多功能组合',
      bgColor: 'linear-gradient( 139deg, #0C45FF 0%, #43F2FF 100%)',
      linkUrl: window.SITE_CONFIG.aigcBaseUrl + '/#/making'
    }
  ],
  // 4
  currentIndex: 0, // 当前索引
  applicationDataOnePage: [
    {
      img: 'https://cdn.photosir.cn/paramter/800209207608475648.png',
      name: '0基础实现设计大师梦',
      introduce: '图像处理快速编辑',
      bgColor: 'linear-gradient( 137deg, #5443FF 0%, #97FF9B 100%)',
      linkUrl: window.SITE_CONFIG.officialWebsiteBaseUrl + '/#/PhotoSirSoftware'
    },
    {
      img: 'https://cdn.photosir.cn/paramter/800210227340247040.png',
      name: '实时绘画，灵感随心飞',
      introduce: '人人都是绘画大师',
      bgColor: 'linear-gradient( 144deg, #837AFF 0%, #3049D8 100%)',
      linkUrl: window.SITE_CONFIG.officialWebsiteBaseUrl + '/#/AiFlashDrawing'
    },
    {
      img: 'https://cdn.photosir.cn/paramter/800210345254715392.png',
      name: '让编程更容易',
      introduce: '新一代图形化编程软件',
      bgColor: 'linear-gradient( 139deg, #59B3F8 0%, #5283F4 100%)',
      linkUrl: window.SITE_CONFIG.officialWebsiteBaseUrl + '/#/Program'
    },
    {
      img: 'https://cdn.photosir.cn/paramter/800210461478879232.png',
      name: '一分钟搞定相册处理',
      introduce: '专业级相册处理',
      bgColor: 'linear-gradient( 134deg, #D064FF 3%, #783FE1 100%)',
      linkUrl: window.SITE_CONFIG.officialWebsiteBaseUrl + '/#/Registering'
    },
  ],
  applicationDataTwoPage: [
    {
      img: 'https://cdn.photosir.cn/paramter/800210574070775808.png',
      name: '看图片更轻松',
      introduce: '图片浏览管理器',
      bgColor: 'linear-gradient( 139deg, #3484F6 0%, #55B7EA 100%)',
      linkUrl: window.SITE_CONFIG.officialWebsiteBaseUrl + '/#/LookPicture'
    },
    {
      img: 'https://cdn.photosir.cn/paramter/800210791163756544.png',
      name: '享受拼图乐趣',
      introduce: '照片拼接留住生活美好',
      bgColor: 'linear-gradient( 144deg, #837AFF 0%, #3049D8 100%)',
      linkUrl: window.SITE_CONFIG.officialWebsiteBaseUrl + '/#/PhotoSplicing'
    },
    {
      img: 'https://cdn.photosir.cn/paramter/800210937670795264.png',
      name: '高校、简单、跨平台传输',
      introduce: '图片传输助手',
      bgColor: 'linear-gradient( 137deg, #5443FF 0%, #97FF9B 100%)',
      linkUrl: window.SITE_CONFIG.officialWebsiteBaseUrl + '/#/PhotoUpload'
    },
    {
      img: 'https://cdn.photosir.cn/paramter/800211039697240064.png',
      name: 'AI赋能，一键生成梦想中的图片',
      introduce: '智能图像创造者',
      bgColor: 'linear-gradient( 144deg, #837AFF 0%, #3049D8 100%)',
      linkUrl: window.SITE_CONFIG.aigcBaseUrl
    }
  ],
  // 新闻中心3条数据
  newsCenterData: [],
  // 7
  thirdList: [
      {
        path: 'https://www.xiaohongshu.com/user/profile/60af4a250000000001004121',
        icon: require('../assets/images/footer/xhs.png'),
        name: '小红书'
      },
      {
        path: 'https://space.bilibili.com/1204833800?spm_id_from=333.1007.0.0',
        icon: require('../assets/images/footer/bilibili.png'),
        name: '哔哩哔哩'
      },
      {
        path: 'https://www.douyin.com/search/%E5%8C%97%E4%BA%AC%E4%BA%A6%E5%BF%83%E7%A7%91%E6%8A%1600pxE6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8',
        icon: require('../assets/images/footer/dy.png'),
        name: '抖音'
      },
      {
        path: 'https://www.zhihu.com/org/wu-kong-tu-xiang',
        icon: require('../assets/images/footer/zh.png'),
        name: '知乎'
      },
      {
        path: 'https://mp.weixin.qq.com/s/g7fcrRoIy2GDPt12YugLGw',
        icon: require('../assets/images/footer/sph.png'),
        name: '微信视频号'
      },
      {
        path: 'https://www.youtube.com/@PhotoSir365/featured',
        icon: require('../assets/images/footer/ytb.png'),
        name: 'YouTube'
      },
      {
        path: 'https://www.facebook.com/profile.php?id=100091333211156',
        icon: require('../assets/images/footer/f.png'),
        name: 'Facebook'
      }
    ]
})
const schoolDetails = (type) => {
  // router.push({
  //   path: '/CustomerCase',
  //   query: { type: type }
  // })
  const url = window.SITE_CONFIG.officialWebsiteBaseUrl + '/#/CustomerCase?type=' + type
  window.open(url, '_blank')
}
// 打开活动页面
const gotoOpen = (url) => {
  // let routeData = router.resolve('/LenovoCompetition')
  if (url) {
    window.open(url, '_blank')
  }
}
//跳转到新闻中心
const gotoNew = () => {
  const url = window.SITE_CONFIG.officialWebsiteBaseUrl + '/#/CompanyNews'
  window.open(url, '_blank')
}
// 定义一个常量OS_NAME，用于存储浏览器用户代理的字符串表示，并将其转换为小写形式
const OS_NAME = navigator.userAgent.toLowerCase()
// 定义一个函数ptype，用于处理下载按钮的事件
function ptype(e) {
  // 创建一个包含多个参数的对象param
  const param = {
    ptype: e.sysversion,
    url: e.url,
    source: 3,
    osname: OS_NAME
  };
  // 调用getclicks函数并传递param对象作为参数
  getclicks(param)
}
// 获取版本信息的异步函数
// const versionInfo = async () => {
//   try {
//     // 调用getInstallPackUrl函数，获取安装包URL
//     const response = await getInstallPackUrl({})
//     // 从响应中提取数据
//     const { data } = response
//     // 判断设备类型
//     const isMobile = isMobileDevice()
//     // 根据设备类型设置 productid_key
//     state.productData[1].productid_key = isMobile ? 'products_name_20' : 'products_name_31'
//     // 遍历 productData 数组，为每个产品设置下载链接
//     for (const product of state.productData) {
//       // 在数据中查找目标产品
//       const targetProduct = data.find(e => e.productid === product.productid_key)
//       console.log('查找产品', targetProduct)
//       if (targetProduct) {
//         // 根据设备类型查找对应的升级包
//         let targetSysApp
//         if (!isMobile) {
//           // 电脑端下载链接的设置逻辑
//           const agent = window.navigator.userAgent.toLowerCase()
//           const isMac = /macintosh|mac os x/i.test(agent)
//           const isWindows = agent.indexOf('win32') >= 0 || agent.indexOf('wow32') >= 0
//           const targetSysVersion = isMac ? 'X86/M1' : isWindows ? 'win32' : 'win64'
//           targetSysApp = targetProduct.upgradepackagevolist.find(item => item.sysversionname === targetSysVersion || item.sysversionname === 'MAC')
//         } else {
//           // 手机端下载链接的设置逻辑
//           const agent = window.navigator.userAgent.toLowerCase()
//           const isIOS = /iphone|ipad|ipod/i.test(agent)
//           const isAndroid = /android/i.test(agent)
//           if (isIOS) {
//             targetSysApp = targetProduct.upgradepackagevolist.find(item => item.sysversionname.toLowerCase().includes('ios'))
//           } else if (isAndroid) {
//             targetSysApp = targetProduct.upgradepackagevolist.find(item => item.sysversionname.toLowerCase().includes('安卓'))
//           }
//         }
//         console.log('匹配手机', targetSysApp)
//         if (targetSysApp) {
//           // 设置下载链接
//           product.downloadUrlData = targetSysApp
//           console.log('下载链接', product.downloadUrlData)
//         }
//       }
//     }
//   } catch (error) {
//     // 捕获并打印错误信息
//     console.error('Error fetching version info:', error)
//   }
// }
// function isMobileDevice() {
//   const agent = window.navigator.userAgent.toLowerCase()
//   return /mobile|android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(agent)
// }
const versionInfo = async () => {
  try {
    // 调用getInstallPackUrl函数，获取安装包URL
    const response = await getInstallPackUrl({})
    // 从响应中提取数据
    const { data } = response
    // 判断设备类型
    const isMobile = isMobileDevice()
    const isIOS = isMobile && /iphone|ipad|ipod/i.test(window.navigator.userAgent.toLowerCase())
    const isAndroid = isMobile && /android/i.test(window.navigator.userAgent.toLowerCase())
    // 根据设备类型设置 productid_key
    state.productData[1].productid_key = isMobile ? 'products_name_20' : 'products_name_31'
    // 遍历 productData 数组，为每个产品设置下载链接
    for (const product of state.productData) {
      // 在数据中查找目标产品
      const targetProduct = data.find(e => e.productid === product.productid_key)
      if (targetProduct) {
        // 查找匹配的升级包
        let targetSysApp = findTargetSysApp(targetProduct, isMobile, isIOS, isAndroid)
        if (targetSysApp) {
          // 设置下载链接
          product.downloadUrlData = targetSysApp
          console.log('下载链接', product.downloadUrlData)
        } else {
          console.log('未找到匹配的升级包')
        }
      }
    }
  } catch (error) {
    // 捕获并打印错误信息
    console.error('Error fetching version info:', error)
  }
}
function findTargetSysApp(targetProduct, isMobile, isIOS, isAndroid) {
  if (!isMobile) {
    // 电脑端逻辑
    const agent = window.navigator.userAgent.toLowerCase()
    const isMac = /macintosh|mac os x/i.test(agent)
    const isWindows = agent.indexOf('win32') >= 0 || agent.indexOf('wow32') >= 0
    const targetSysVersion = isMac ? 'X86/M1' : isWindows ? 'win32' : 'win64'
    return targetProduct.upgradepackagevolist.find(item => item.sysversionname === targetSysVersion || item.sysversionname === 'MAC')
  } else if (isIOS) {
    // iOS 设备逻辑
    return targetProduct.upgradepackagevolist.find(item => item.sysversionname.toLowerCase().includes('ios'))
  } else if (isAndroid) {
    // 安卓设备逻辑
    return targetProduct.upgradepackagevolist.find(item => item.sysversionname.toLowerCase().includes('安卓'))
  }
  return null
}
function isMobileDevice() {
  const agent = window.navigator.userAgent.toLowerCase()
  return /mobile|android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(agent)
}
// p4 切换上下页
const carouselRef = ref(null)
const prev = () => {
  state.currentIndex = (state.currentIndex - 1 + state.applicationDataOnePage.length) % 2
  carouselRef.value.prev()
}
const next = () => {
  state.currentIndex = (state.currentIndex + 1) % 2
  carouselRef.value.next()
}
/**
 * 跳转到指定页面
 */
const goToOpenUrl = (item) => {
  if (item.linkUrl) {
    window.open(item.linkUrl, '_blank')
    // window.location.href = item.linkUrl
  }
}
/**
 * 获取新闻列表
 */
 const getNewsListData = () => {
  let params = {
    limit: 3,
    page: 1,
  };
  getNewsList(params).then((res) => {
    if (res.code === 0) {
      state.newsCenterData = res.data.list
    }
  })
}
// 访问量统计
const imprint = (e) => {
  const thcode = getThCode(e)
  let param = {
    thcode: thcode,
    source: 3
  };
  getVisit(param).then(res => {
    console.log(res)
  }).catch(error => {
    console.error("Error fetching visit data:", error)
  })
}
// 定义一个名为getThCode的函数，接收一个参数e
const getThCode = (e) => {
  if (route.query.thcode !== undefined && route.query.thcode !== null && route.query.thcode !== '') {
    return route.query.thcode
  } else {
    return e
  }
}

/**
 * 新闻--进入详情页
 */
 const itemClick = (item) => {
  let query = { newsId: item.id }
  router.push({
    name: 'CompanyNewsDetails',
    query: {
      ...route.query,
      ...query
    }
  })
}
const isPhone = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
let timerId // 用于存储定时器的ID
const startSwitch = () => {
  timerId = setInterval(next, 3000) // 每三秒调用一次next函数
}
const stopThreeSwitch = () => {
  clearInterval(timerId) // 清除定时器
}
onMounted(() => {
  startSwitch()
  imprint('GW')
  versionInfo()
  getNewsListData()
})
onUnmounted(() => {
  stopThreeSwitch() // 组件卸载时清除定时器
})
</script>

<style lang="scss" scoped>
.PhotoSir{
  font-family: Microsoft YaHei, Microsoft YaHei;
}
.banner-img-box{
  // height: 450px;
  .banner-switch{
    // height: 450px;
    .el-carousel__item {
      height: 450px;
    }
  }
}
// 2
.product-download{
  padding-top: 40px;
  background-color: #fff;
  .product-box{
    width: 1600px;
    display: flex;
    justify-content: space-between;
    .photosir-img{
      width: 644px;
      margin: 0 auto;
      border-radius: 10px 10px 0 0;
    }
  }
  .product-card{
    width: 790px;
    height: 518px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .product-headImg{
      margin: 40px 16px 40px 40px;
      width: 70px;
      height: 70px;
    }
    .product-name{
      font-size: 32px;
      font-weight: 600;
      font-family: Microsoft YaHei, Microsoft YaHei;
    }
    .product-introduce{
      color: #666666;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-size: 14px;
    }
    .btn-down{
      width: 180px;
      height: 56px;
      line-height: 56px;
      margin-right: 40px;
      background-color: #257CFF;
      border-radius: 50px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-size: 22px;
      img{
        margin-left: 10px;
        width: 28px;
        height: 28px;
      }
    }
  }
  .product-card:nth-child(1){
    margin-right: 20px;
    background-image: url('https://cdn.photosir.cn/paramter/800226655598542848.png');
  }
  .product-card:nth-child(2){
    background-image: url('https://cdn.photosir.cn/paramter/800226757381718016.png');
  }
}
// 3
.fun-section{
  background-color: #F6F6F6;
  .fun-box{
    width: 1600px;
    h2{
      padding: 120px 0 70px 0;
    }
  }
  .fun-card-box{
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 80px;
  }

  .fun-card{
    width: 370px;
    height: 186px;
    margin-right: 40px;
    border-radius: 20px;
    padding:36px 40px 40px 36px;
    margin-bottom: 40px;
    .fun-img{
      width: 48px;
      height: 48px;
    }
    .fun-name{
      font-size: 24px;
      line-height: 32px;
      font-weight: bold;
    }
    .fun-introduce{
      margin-top: 5px;
      line-height: 16px;
      font-size: 12px;
    }
    .goTo{
      width: 95px;
      height: 34px;
      align-items: center;
      justify-content: center;
      font-size: 13px;
      border: 2px solid #fff;
      border-radius: 50px;
      img{
        margin-left: 10px;
        width: 15px;
      }
    }
  }
  .fun-card:nth-child(4n) {
    margin-right: 0;
  }
}
// 4
:deep(.application-scenarios){
  padding: 120px 0;
  background-color: #000;
  .el-carousel{
    height: 530px;
    .el-carousel__container{
      height: 530px !important;
    }
  }
  .phone-show{
    display: none ;
  }
  .box{
    width: 1600px;
    .phone-hide{
      display: block;
    }
    .currPage{
      font-size: 28px;
      img{
        width: 32px;
        height: 32px;
      }
    }
    .introduce{
      margin: 10px 0 60px 0;
      font-size: 20px;
      color: #999999;
    }
  }
  .card-box{
    width: 1600px;
    margin: auto;
    .application-card{
      width: 389px;
      height: 530px;
      border-radius: 20px;
      margin-right: 20px;
      .name{
        font-size: 16px;
        img{
          width: 20px;
          height: 20px;
        }
      }
      .introduce{
        font-size: 28px;
      }
    }
  }
}
// 5
.customer-case{
  padding: 120px 0;
  background: linear-gradient(180deg, #FFFFFF 0%,  #FFFACD 80%, #FFFFFF 100%);
  .case-box{
    width: 1600px;
    .introduce {
      margin: 20px 0 70px 0;
      font-size: 20px;
      color: #666666;
    }
    .case-1{
      position: relative;
      width: 964px;
      height: 560px;
      border-radius: 20px;
      background-size: 100% 100%;
      margin-right: 26px;
      background-image: url('https://cdn.photosir.cn/paramter/804172339607502848.jpg');
      .info{
        position: absolute;
        padding: 0 86px 21px 34px;
        bottom: 0;
        color: #fff;
        background: linear-gradient( 360deg, #000000 0%, rgba(255,255,255,0) 100%);
        border-radius: 20px 20px 20px 20px;
        .scheme-title{
          line-height: 37px;
          font-size: 28px;
          font-weight: bold;
          margin-bottom: 20px;
        }
        .conternt{
          font-weight: 300;
          line-height: 24px;
          font-size: 18px;
        }
      }
    }
    .case-2,.case-3{
      position: relative;
      width: 610px;
      height: 270px;
      border-radius: 20px;
      border-radius: 20px 20px 20px 20px;
      background-size: 100% 140% !important;
      background-position: 0 -70px;
      div{
        position: absolute;
        left: 34px;
        bottom: 24px;
        font-size: 28px;
        line-height: 28px;
        font-weight: bold;
        color: #fff;
      }
    }
    .case-2{
      background-image: url('http://cdn.photosir.cn/paramter/804174786207940608.jpg');
    }
    .case-3{
      margin-top: 20px;
      background-image: url('https://cdn.photosir.cn/paramter/804175445300871168.jpg');
    }
  }
}
// 6
.new-center{
  padding: 120px 0;
  background-color: #F6F6F6;
  .new-box{
    width: 1600px;
    .more-phone{
      display: none;
    }
    .introduce {
      margin: 10px 0 70px 0;
      font-size: 20px;
      color: #666666;
    }
    .new-info{
      padding: 42px 30px;
      .title{
        margin-bottom: 48px;
      }
    }
    .more{
      display: block;
      width: 130px;
      height: 42px;
      line-height: 42px;
      font-size: 16px;
      border-radius: 50px;
      background: linear-gradient( 139deg, #F6514E 0%, #BF25E4 100%);
      img{
        width: 20px;
      }
    }
    .news-Center-card{
      width: 518px;
      background: #FFFFFF;
      border-radius: 20px;
      .cover-image-box{
        display: flex;
        justify-content: center;
        background-color: #000;
        width: 518px;
        height: 283.05px;
        border-radius: 20px 20px 0 0;
      }
      .title{
        line-height: 32px;
        font-weight: 400;
        font-size: 24px;
      }
      .item-more{
        font-size: 14px;
        color: #2870F6;
      }
    }
  }
}
h2{
  font-size: 48px;
  font-weight: bold;
  font-family: Microsoft YaHei, Microsoft YaHei;
}
.outer-net{
  height: 42px;
}

@media (min-width: 1600px){
// 2
.product-download{
  padding-top: 40px;
  .product-box{
    width: 1600PX;
    .photosir-img{
      width: 644PX;
    }
  }
  .product-card{
    width: 790PX;
    height: 518PX;
    .product-headImg{
      margin: 40PX 16PX 40PX 40PX;
      width: 70PX;
      height: 70PX;
    }
    .product-name{
      font-size: 32PX;
    }
    .product-introduce{
      font-size: 14PX;
    }
    .btn-down{
      width: 180PX;
      height: 56PX;
      line-height: 56PX;
      margin-right: 40PX;
      font-size: 22PX;
      img{
        margin-left: 10PX;
        width: 28PX;
        height: 28PX;
      }
    }
  }
  .product-card:nth-child(1){
    margin-right: 20PX;
  }
}
// 3
.fun-section{
  .fun-box{
    width: 1600PX;
    h2{
      padding: 120PX 0 70PX 0;
    }
  }
  .fun-card-box{
    padding-bottom: 80PX;
  }

  .fun-card{
    width: 370PX;
    height: 186PX;
    margin-right: 40PX;
    border-radius: 20PX;
    padding:36PX 40PX 40PX 36PX;
    margin-bottom: 40PX;
    .fun-img{
      width: 48PX;
      height: 48PX;
    }
    .fun-name{
      font-size: 24PX;
      line-height: 32PX;
    }
    .fun-introduce{
      line-height: 16PX;
      font-size: 12PX;
    }
    .goTo{
      width: 95PX;
      height: 34PX;
      font-size: 13PX;
      border: 2PX solid #fff;
      img{
        margin-left: 10PX;
        width: 15PX;
      }
    }
  }
}
// 4
:deep(.application-scenarios){
  .el-carousel{
    height: 530PX;
    .el-carousel__container{
      height: 530PX !important;
    }
  }
  padding: 120PX 0;
  .box{
    width: 1600PX;
    .currPage{
      font-size: 28PX;
      img{
        width: 32PX;
        height: 32PX;
      }
    }
    .introduce{
      margin: 10PX 0 70PX 0;
      font-size: 20PX;
    }
  }
  .card-box{
    width: 1600PX;
    .application-card{
      width: 389PX;
      height: 530PX;
      margin-right: 20PX;
      .name{
        font-size: 16PX;
        img{
          width: 20PX;
          height: 20PX;
        }
      }
      .introduce{
        font-size: 28PX;
      }
    }
  }
}
// 5
.customer-case{
  padding: 120PX 0;
  .introduce {
    margin: 10PX 0 70PX 0;
    font-size: 20PX;
  }
  .case-box{
    width: 1600PX;
    .case-1{
      width: 964PX;
      height: 560PX;
      margin-right: 26PX;
      border-radius: 20PX;
      .info{
        padding: 0 86PX 21PX 34PX;
        bottom: 0;
        .title{
          line-height: 37PX;
          font-size: 28PX;
          margin-bottom: 20PX;
        }
        .conternt{
          font-weight: 300;
          line-height: 24PX;
          font-size: 18PX;
        }
      }
    }
    .case-2,.case-3{
      width: 610PX;
      height: 270PX;
      div{
        left: 34PX;
        bottom: 24PX;
        font-size: 28PX;
        line-height: 28PX;
      }
    }
    .case-3{
      margin-top: 20PX;
    }
  }
}
// 6
.new-center{
  padding: 120PX 0;
  .new-box{
    width: 1600PX;
    .introduce {
      margin: 10PX 0 70PX 0;
      font-size: 20PX;
    }
    .new-info{
      padding: 42PX 30PX;
      .title{
        margin-bottom: 48PX;
      }
    }
    .more{
      width: 130PX;
      height: 42PX;
      line-height: 42PX;
      font-size: 16PX;
      img{
        width: 20PX;
      }
    }
    .news-Center-card{
      width: 518PX;
      .cover-image-box{
        width: 518PX;
        height: 283.05PX;
      }
      .title{
        line-height: 32PX;
        font-size: 24PX;
      }
      .item-more{
        font-size: 14PX;
      }
    }
  }
}
h2{
  font-size: 48PX;
}
.outer-net{
  height: 42PX;
}
}
@media (max-width: 1024px) {
  .page-content{
    padding-top: 3rem;
  }
}
@media (min-width: 567px) {
  .banner-img-box{
    height: 370px;
    .banner-switch{
      height: 370px;
    }
  }
}

@media (max-width: 567px){
  .product-download .product-box,.fun-section .fun-box,.application-scenarios ,.customer-case .case-box,.new-center .new-box{
    width: 100%;
    padding: 0 17PX !important;
   }
   .product-box{
    flex-wrap: wrap;
    .photosir-img{
      width: 100% !important;
      padding: 0 31px !important;
    }
   }
   .product-download {
      padding-bottom: 30px !important;
      padding-top: 14px !important;
      .product-card{
        width: 100% !important;
        height: 400px !important;
        margin-right: 0 !important;
        border-radius: 20px !important;
        .product-name{
          font-size: 28px !important;
        }
        .product-headImg{
          margin: 20PX 8PX 20PX 15PX !important;
        }
        .btn-down{
          width: 8.5rem !important;
          margin-right: 15px !important;
          img{
            margin-left: 0 !important;
          }
        }
      }
      .product-card:nth-child(2){
        margin-top: 14px !important;
      }
   }
   .fun-section {
    .fun-card-box{
      justify-content: space-between;
      padding-bottom: 30PX;
    }
    .fun-card{
      width: 100% !important;
      margin-right: 0 !important;
      margin-bottom: 14px !important;
      .goTo{
        width: 140px;
        height: 50px;
        font-size: 18px;
        img{
          width: 25px;
          height: 25px;
        }
      }
      .fun-name{
        font-size: 28px;
      }
      .fun-introduce{
        margin-top: 15px;
        font-size: 20px;
      }
          }
    .fun-box{
      h2{
        padding: 30PX 0 20px 17px !important;
        font-size: 38px !important;
      }
    }
   }
   .customer-case{
    padding: 30PX 0 30PX 0;
    .case-box{
      .introduce{
        margin: 10PX 0 20PX 0;
      }
      .cases{
        flex-direction: column;
      }
      .case-1{
        margin-right: 0;
        margin-bottom: 20px;
        .info{
          left: 0px;
          bottom: 0px;
          font-weight: 500;
          .conternt{
            line-height: 34px;
            font-size: 24px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1; /* 限制显示的行数为2 */
            overflow: hidden;
            text-overflow: ellipsis; /* 当文本溢出时显示省略号 */
          }
        }
      }
      .case-1, .case-2, .case-3{
        width: 100%;
        height: 270px;
        div{
          left: 14PX;
          bottom: 28px;
          font-weight: 600;
        }
      }
    }
   }
   .new-center{
    padding: 30PX 0;
    .more{
      display: none !important;
    }
    .more-phone{
      margin: 40PX 0 0 0;
      width: 100%;
      height: 50PX;
      line-height: 50PX;
      font-size: 28px;
      border-radius: 50PX;
      font-weight: 400;
      font-family: 苹方-简, 苹方-简;
      background: linear-gradient( 139deg, #F6514E 0%, #BF25E4 100%);
      display: block !important;
    }
   }
   .application-scenarios{
    padding-top: 60px !important;
    padding-bottom: 60px !important;
    .introduce{
      width: 500px;
    }
   }
  .phone-hide{
    display: none !important;
  }
  .phone-roll{
      display: inline-block;
      overflow-x: auto; /* 允许横向滚动 */
      white-space: nowrap; /* 保持子元素在一行内 */
      -webkit-overflow-scrolling: touch; /* 启用平滑滚动（iOS） */
      width: 100% !important;
      .news-Center-card, .application-card{
        display: inline-block;
        margin-right: 20PX; /* 子元素之间的间距 */
        .cover-image-box{
          margin: auto;
          width: 418px !important;
        }
        .new-info{
          .title{
            white-space: pre-wrap;
          }
        }
      }
    }
  .phone-show{
    display: block !important;
  }
   .external-jump{
    justify-content: initial !important;
    a{
      margin-right: 10px;
      margin-bottom: 30px;
    }
   }
}
a {
    text-decoration: none; /* 移除下划线 */
    color: inherit; /* 继承父元素的文字颜色，或者你可以设置为具体的颜色值 */
    background-color: transparent; /* 移除背景颜色 */
    cursor: auto; /* 设置光标样式为默认，或根据需要调整 */
    outline: none; /* 移除焦点时的轮廓线，但通常不建议这样做，因为它会影响可访问性 */
    border: none; /* 移除边框 */
    padding: 0; /* 移除内边距 */
    margin: 0; /* 移除外边距 */
}
a:hover,
a:focus {
    text-decoration: none; /* 在悬停和焦点状态下也移除下划线 */
    outline: none; /* 同样，通常不建议移除焦点轮廓线 */
}
a:active {
    text-decoration: none; /* 在激活状态下也移除下划线 */
}
</style>
